import React from 'react';
import { re_num } from '~/skills/TextRules';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Select, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  ship_name: '',
};

const boatList = [
  { name: '船1', value: '船1' },
  { name: '船2', value: '船2' },
];
const App = ({ titleWidth, disabled, checkSubChange, changeData, data }) => {
  const sub5 = data.sub5 || [];
  const total = re_num(data.provide_num) ? (parseInt(data.provide_num) > 10 ? 0 : parseInt(data.provide_num)) : 0;
  const ary_data = [];
  for (let i = 0; i < total; i++) {
    ary_data.push(
      sub5[i] || { ...emptyBody },
    );
  }
  const ary = [];

  const saveSub = dataAry => {
    changeData({ label: 'sub5', data: dataAry });
  };

  ary.push(
    <EAA_Row key='Page_IAMaritime_sub5'>
      <EAA_Item>
        <EAA_ItemContainer>
          <EAA_TitleText width={titleWidth} text='船舶名稱' haveChange={checkSubChange(5, [emptyBody])} />
          {total < 1 && <div>{'需輸入船舶供應數量（最多10艘）'}</div>}
          {total >= 1 && <EAA_Select displayBorder disabled={disabled} list={boatList} value={ary_data[0].ship_name} onChange={data => { ary_data[0].ship_name = data; saveSub(ary_data); }} />}
        </EAA_ItemContainer>
        {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
      </EAA_Item>
      <EAA_Item />
    </EAA_Row>,
  );
  for (let i = 1; i < ary_data.length; i++) {
    ary.push(
      <EAA_Row key={`Page_IAMaritime_sub5_${i}`}>
        <EAA_Item>
          <EAA_ItemContainer>
            <EAA_TitleText width={titleWidth} />
            <EAA_Select displayBorder disabled={disabled} list={boatList} value={ary_data[i].ship_name} onChange={data => { ary_data[i].ship_name = data; saveSub(ary_data); }} />
          </EAA_ItemContainer>
          {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
        </EAA_Item>
        <EAA_Item />
      </EAA_Row>,
    );
  }
  return ary;
};

export default App;
